import type { AdminClientContext, AdminHttpClient } from './client.js';

type MethodKeys =
  | 'getTenantLoginDefaultModel'
  | 'updateTenantLoginDefaultModel';

export function buildModelsMethods(ctx: AdminClientContext) {
  const { transport, token, idemKey } = ctx;

  return {
    getTenantLoginDefaultModel: () =>
      transport.getTenantLoginDefaultModel(token()),
    updateTenantLoginDefaultModel: (loginDefaultModelId, idempotencyKey) =>
      transport.updateTenantLoginDefaultModel(token(), {
        loginDefaultModelId,
        idempotencyKey: idempotencyKey ?? idemKey()
      })
  } satisfies Pick<AdminHttpClient, MethodKeys>;
}
